export default __webpack_public_path__ + "static/media/in-the-aeroplane-over-the-sea.e0258e5e.jpg";